"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reduxApiClient = require("@spq/redux-api-client");
var responseTransformation = _interopRequireWildcard(require("./utils/responseTransformUtils"));
var requestTransformation = _interopRequireWildcard(require("./utils/requestTransformUtils"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const createEcomApi = Api => {
  class EcomApi extends Api {
    constructor() {
      super(...arguments);
      _defineProperty(this, "previewOrder", new _reduxApiClient.Endpoint({
        endpoint: "orders/preview/",
        method: "POST",
        transformRequest: requestTransformation.transformPreviewOrderRequest,
        reducer: "",
        includeToken: true
      }));
      _defineProperty(this, "placeOrder", new _reduxApiClient.Endpoint({
        endpoint: "orders/",
        method: "POST",
        transformRequest: requestTransformation.transformPlaceOrderRequest,
        transformResponse: responseTransformation.preparePlaceOrderResponse,
        includeToken: true
      }));
      _defineProperty(this, "replaceOrderPreview", new _reduxApiClient.Endpoint({
        endpoint: "orders/reorder/preview/%s/",
        transformRequest: requestTransformation.transformReplaceOrderPreviewRequest,
        reducer: "",
        includeToken: true
      }));
      _defineProperty(this, "orders", new _reduxApiClient.Endpoint({
        endpoint: "orders/",
        version: "v2",
        transformRequest: requestTransformation.prepareOrdersRequest,
        transformResponse: responseTransformation.prepareOrdersResponse,
        includeToken: true
      }));
      _defineProperty(this, "addFavoriteMenuItem", new _reduxApiClient.Endpoint({
        endpoint: "customers/customer-favorite-menu/",
        method: "POST",
        transformRequest: requestTransformation.transformAddFavoriteMenuItemRequest,
        transformResponse: responseTransformation.prepareAddFavoriteMenuItemResponse,
        includeToken: true
      }));
      _defineProperty(this, "favoriteMenuItems", new _reduxApiClient.Endpoint({
        endpoint: "customers/customer-favorite-menu/",
        version: "v2",
        transformRequest: requestTransformation.prepareFavoriteMenuItemsRequest,
        transformResponse: responseTransformation.prepareFavoriteMenuItemsResponse,
        includeToken: true
      }));
      _defineProperty(this, "cancelOrder", new _reduxApiClient.Endpoint({
        endpoint: "orders/%s/cancel/",
        method: "PATCH",
        transformRequest: requestTransformation.transformCancelOrderRequest,
        reducer: "user",
        includeToken: true
      }));
      _defineProperty(this, "removeFavoriteMenuItem", new _reduxApiClient.Endpoint({
        endpoint: "customers/customer-favorite-menu/%s/",
        method: "DELETE",
        transformRequest: requestTransformation.transformRemoveFavoriteMenuItemRequest,
        transformResponse: responseTransformation.prepareRemoveFavoriteMenuItemResponse,
        includeToken: true
      }));
      _defineProperty(this, "editFavoriteMenuItem", new _reduxApiClient.Endpoint({
        endpoint: "customers/customer-favorite-menu/%s/",
        method: "PATCH",
        transformRequest: requestTransformation.transformEditFavoriteMenuItemRequest,
        transformResponse: responseTransformation.prepareEditFavoriteMenuItemResponse,
        includeToken: true
      }));
      _defineProperty(this, "customerAddresses", new _reduxApiClient.Endpoint({
        endpoint: "customers/addresses/",
        transformResponse: responseTransformation.prepareCustomerAddressesResponse,
        reducer: "user",
        includeToken: true
      }));
      _defineProperty(this, "addCustomerAddress", new _reduxApiClient.Endpoint({
        endpoint: "customers/addresses/",
        method: "POST",
        transformRequest: requestTransformation.transformAddCustomerAddressRequest,
        transformResponse: responseTransformation.prepareAddCustomerAddressResponse,
        reducer: "user",
        includeToken: true
      }));
      _defineProperty(this, "removeCustomerAddress", new _reduxApiClient.Endpoint({
        endpoint: "customers/addresses/%s/",
        method: "DELETE",
        transformRequest: requestTransformation.transformRemoveCustomerAddressRequest,
        transformResponse: responseTransformation.prepareRemoveCustomerAddressResponse,
        reducer: "user",
        includeToken: true
      }));
      _defineProperty(this, "diningChoiceOptions", new _reduxApiClient.Endpoint({
        endpoint: "orders/dining_choices/",
        method: "GET",
        reducer: "order",
        transformResponse: responseTransformation.prepareDiningChoicesResponse
      }));
      _defineProperty(this, "gglocations", new _reduxApiClient.Endpoint({
        endpoint: "locations/",
        transformResponse: responseTransformation.prepareGglocationsResponse
      }));
      _defineProperty(this, "storeBusy", new _reduxApiClient.Endpoint({
        endpoint: "locations/storebusy/",
        transformResponse: responseTransformation.prepareStoreBusyResponse
      }));
      _defineProperty(this, "gglocationsImages", new _reduxApiClient.Endpoint({
        endpoint: "locations/images/",
        transformResponse: responseTransformation.prepareImagesResponse
      }));
      _defineProperty(this, "images", new _reduxApiClient.Endpoint({
        endpoint: "images/",
        transformResponse: responseTransformation.prepareImagesResponse
      }));
      _defineProperty(this, "ingredients", new _reduxApiClient.Endpoint({
        endpoint: "ingredients/",
        transformResponse: responseTransformation.prepareIngredientsResponse
      }));
      _defineProperty(this, "gglocationMenuGroups", new _reduxApiClient.Endpoint({
        endpoint: "gglocation-menus/gglocations/",
        transformResponse: responseTransformation.prepareGglocationMenuGroupsResponse
      }));
      _defineProperty(this, "unavailableIngredients", new _reduxApiClient.Endpoint({
        endpoint: "gglocation-menus/disabled-ingredients/",
        transformResponse: responseTransformation.prepareUnavailableIngredientsResponse
      }));
      _defineProperty(this, "bases", new _reduxApiClient.Endpoint({
        endpoint: "base-types/",
        transformResponse: responseTransformation.responseArrayToObject
      }));
      _defineProperty(this, "menuCategories", new _reduxApiClient.Endpoint({
        endpoint: "menu-categories/",
        transformResponse: responseTransformation.responseArrayToObject
      }));
      _defineProperty(this, "nutrients", new _reduxApiClient.Endpoint({
        endpoint: "nutrients/",
        transformResponse: responseTransformation.responseArrayToObject
      }));
      _defineProperty(this, "ingredientCategories", new _reduxApiClient.Endpoint({
        endpoint: "ingredient-categories/",
        transformResponse: responseTransformation.responseArrayToObject
      }));
      _defineProperty(this, "ingredientGroups", new _reduxApiClient.Endpoint({
        endpoint: "ingredient-groups/",
        transformResponse: responseTransformation.responseArrayToObject
      }));
      _defineProperty(this, "tags", new _reduxApiClient.Endpoint({
        endpoint: "tags/",
        transformResponse: responseTransformation.responseArrayToObject
      }));
      _defineProperty(this, "cyoSections", new _reduxApiClient.Endpoint({
        endpoint: "cyo-section/",
        transformResponse: responseTransformation.responseArrayToObject
      }));
      _defineProperty(this, "servingNumberVariations", new _reduxApiClient.Endpoint({
        endpoint: "serving-number-variations/",
        transformResponse: responseTransformation.prepareServingNumberVariationsResponse
      }));
      _defineProperty(this, "pricingVariations", new _reduxApiClient.Endpoint({
        endpoint: "pricing-variations/",
        transformResponse: responseTransformation.preparePricingVariationsResponse
      }));
      _defineProperty(this, "preferenceGroups", new _reduxApiClient.Endpoint({
        endpoint: "preference-groups/",
        transformResponse: responseTransformation.responseArrayToObject
      }));
      _defineProperty(this, "menuGroups", new _reduxApiClient.Endpoint({
        endpoint: "gglocation-menus/menu-groups/",
        transformResponse: responseTransformation.prepareMenuGroupsResponse
      }));
      _defineProperty(this, "getMenuGroup", new _reduxApiClient.Endpoint({
        endpoint: "gglocation-menus/menu-groups/%s/",
        transformRequest: requestTransformation.transformGetMenuGroupRequest,
        transformResponse: responseTransformation.prepareGetMenuGroupResponse
      }));
      _defineProperty(this, "settings", new _reduxApiClient.Endpoint({
        endpoint: "settings/",
        transformResponse: responseTransformation.prepareSettingsResponse
      }));
      _defineProperty(this, "landingPages", new _reduxApiClient.Endpoint({
        endpoint: "landing-pages/%s/",
        reducer: "landingPage",
        transformRequest: requestTransformation.transformLandingPageRequest,
        transformResponse: responseTransformation.prepareLandingPageResponse
      }));
      _defineProperty(this, "calculateNutrients", new _reduxApiClient.Endpoint({
        endpoint: "nutritional-calculator/",
        method: "POST",
        reducer: "orderItem",
        version: "v2",
        transformRequest: requestTransformation.transformNutritionalCalculationRequest,
        transformResponse: responseTransformation.prepareNutritionalCalculationResponse
      }));
      _defineProperty(this, "upsellCategories", new _reduxApiClient.Endpoint({
        endpoint: "upsell-categories/",
        version: "v2",
        transformResponse: responseTransformation.responseArrayToObject
      }));
      _defineProperty(this, "pairKiosk", new _reduxApiClient.Endpoint({
        endpoint: "kiosknotify/pair-kiosk/",
        method: "POST",
        includeToken: true,
        transformRequest: requestTransformation.transformPairKioskRequest
      }));
      this.apiName = this.constructor.name;
      this.constructEndpoints(_reduxApiClient.Endpoint);
    }
  }
  return EcomApi;
};
var _default = exports.default = createEcomApi;